var React = require('react');

function BaLogoWhiteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M172.037 130.394l-7.515 20.19h5.875l9.42-28.117a4.41 4.41 0 0 0 .148-1.762q-.1-.625-.972-1.776h0q-1.204-1.587-3.294-2.11h0q1.83-.7 2.855-2.23h0q1.027-1.52 1.027-3.518h0q0-3.66-2.557-5.553h0q-2.557-1.895-7.504-1.895h0H160V130.8h9.582l1.76-4.558q-.444.06-.944.06h0-4.797v-7.336h5.133q3.863.056 3.863 3.79h0q0 .73-.215 1.323h.001l-2.345 6.317zm2.574 14.6h7.55l1.885 5.6H190l-9.057-24.196-2.525 7.416 2.23 6.645h-4.494l-1.544 4.536zm-9.01-36.826v6.85h4.143q4.237-.074 4.237-3.378h0q0-1.848-1.073-2.66h0q-1.073-.812-3.388-.812h0-3.92z","fillRule":"evenodd","fill":"#fff"}));
}

BaLogoWhiteInline.defaultProps = {"viewBox":"160 103.622 30 46.961","width":"40","height":"62.615"};

module.exports = BaLogoWhiteInline;

BaLogoWhiteInline.default = BaLogoWhiteInline;
